import { jwtDecode } from 'jwt-decode';
import { STORAGE_KEYS } from './constants';

// Format date
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// Get time ago
export const getTimeAgo = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
};

// Decode JWT token
export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
};

// Check if token is expired
export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

// Get token from storage
export const getToken = () => {
  return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
};

// Set token in storage
export const setToken = (token) => {
  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
};

// Remove token from storage
export const removeToken = () => {
  localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER_DATA);
};

// Get status badge color
export const getStatusColor = (status) => {
  const colors = {
    'Open': '#ff9800',
    'In Progress': '#2196f3',
    'Closed': '#4caf50',
    'Pending': '#f44336'
  };
  return colors[status] || '#9e9e9e';
};

// Get priority color
export const getPriorityColor = (priority) => {
  const colors = {
    'Low': '#4caf50',
    'Medium': '#ff9800',
    'High': '#f44336',
    'Urgent': '#d32f2f'
  };
  return colors[priority] || '#9e9e9e';
};

// Truncate text
export const truncateText = (text, maxLength = 50) => {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
};

